// Tiny helper for cn (className join)
export function cn(...args) {
  return args.filter(Boolean).join(" ");
}

export function fmtNumber(v, digits = 1) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const abs = Math.abs(v);
  if (abs >= 1e6) return (v / 1e6).toFixed(1) + "M";
  if (abs >= 1e3) return (v / 1e3).toFixed(1) + "k";
  return Number(v).toFixed(digits);
}

export function fmtPct(v, digits = 1) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const sign = v > 0 ? "+" : "";
  return `${sign}${v.toFixed(digits)}%`;
}

export function severityClass(sev) {
  if (sev === "high") return "pill pill-error";
  if (sev === "medium") return "pill pill-warn";
  if (sev === "low") return "pill pill-info";
  return "pill";
}

export function statusPill(status) {
  if (status === "planned") return "pill pill-info";
  if (status === "in_progress") return "pill pill-warn";
  if (status === "completed") return "pill pill-success";
  return "pill";
}
